import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'SortArrows',
    props: {
        sortType: {
            default: 'descending',
            type: String,
            validator(value) {
                return ['ascending', 'descending', ''].includes(value);
            },
        },
        tag: {
            default: 'div',
            type: String,
        },
    },
    emits: ['sort'],
    setup(props, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const title = computed(() => {
            return props.sortType === 'ascending' ? 'Сортировать по убыванию' : 'Сортировать по возрастанию';
        });
        function handleSort() {
            emit('sort', props.sortType);
        }
        return {
            css,
            handleSort,
            title,
        };
    },
});
